/**
 * @file Re-exports the FundingDescriptions component.
 */
import FundingDescriptions from "./FundingDescriptions";

export default FundingDescriptions;
